import { jsx as _jsx } from "react/jsx-runtime";
import ExploreTeam from "Root/profile/components/RDPageV2/ExploreTeam";
import styles from "./styles.module.scss";
const TargetTeam = () => (_jsx("div", { className: styles.team, children: _jsx(ExploreTeam, {}) }));
export default TargetTeam;
